<template>
  <div class="select-day-presentation2">
    <div class="select-day-presentation2__item">
      <div
        class="select-day-presentation2__button"
        :class="{'active': activeType === 'date'}"
        @click="clickDate"
      >
        <div class="select-day-presentation2__left-icon">
          <sprite
            src="sprites_calendar"
          />
        </div>
        <div class="select-day-presentation2__date-text">
          {{ getDateString }}
        </div>
        <sprite
          class="select-day-presentation2__right-icon"
          src="sprites_chevron_down_fixed"
        />
      </div>
    </div>
    <div class="select-day-presentation2__item">
      <div
        class="select-day-presentation2__button"
        :class="{'active': activeType === 'time'}"
        @click="clickTime"
      >
        <div class="select-day-presentation2__left-icon">
          <sprite
            src="sprites_clock"
          />
        </div>
        <div class="select-day-presentation2__time-text">
          {{ getTimeString }}
        </div>
        <sprite
          class="select-day-presentation2__right-icon"
          src="sprites_chevron_down_fixed"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelectedDayAndTimePresentation2',

  props: {
    activeType: {
      type: String,
      default: 'date',
    },

    newDeliveryDate: {
      type: Object,
      required: false,
      default () {
        return null
      },
    },

    isExpressDeliverySelected: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'clickDate',
    'clickTime',
  ],

  computed: {
    ...mapGetters('marketing', ['isExpressDeliveryVisible']),

    getDateString () {
      const {
        date = '',
      } = this.newDeliveryDate

      const dayObj = this.$date(date)

      return `${dayObj.format('DD MMM')}, ${dayObj.format('dd')}`
    },

    getTimeString () {
      if (this.isExpressDeliveryVisible && this.isExpressDeliverySelected && this.$route.name !== 'LandingNewOrder') {
        return 'За 2 часа'
      }
      const {
        timeFrom = '',
        timeTo = '',
        // type = '',
      } = this.newDeliveryDate

      return `${timeFrom}-${timeTo}`
    },
  },

  methods: {
    clickDate () {
      this.$emit('clickDate', true)
    },

    clickTime () {
      this.$emit('clickTime', true)
    },
  },
}
</script>

<style lang="scss">
$prefix: 'select-day-presentation2';

.#{$prefix} {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.#{$prefix}__item {
  max-width: 50%;
  flex: 0 0 50%;
}

.#{$prefix}__button {
  display: flex;
  flex-direction: row;
  align-items: center;

  @include typography('b2', 'bold');

  position: relative;

  padding: 0.16rem 0 0.16rem 0.16rem;

  text-align: left;

  background: map-get($colors, 'grey_2');
  color: map-get($colors, 'grey_60');

  cursor: pointer;

  box-shadow: inset 2px -2px 4px rgba(0, 0, 0, 0.02);

  &.active {
    background: map-get($colors, 'white');
    color: map-get($colors, 'black');

    box-shadow: unset;
  }
}

.#{$prefix}__left-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 0.08rem;

  color: map-get($colors, 'grey_20');

  .c-icon {
    width: 0.16rem;
    height: 0.16rem;
  }
}

.#{$prefix}__right-icon {
  position: absolute;
  top: calc(50% - 0.10rem / 2);
  right: 0.12rem;

  width: 0.10rem;
  height: 0.10rem;

  color: map-get($colors, 'grey_20');

  .#{$prefix}__button.active & {
    transform: rotate(180deg);
    color: map-get($colors, 'grey_40');
  }
}

</style>
